import { useQuery } from "@tanstack/react-query";
import { GetAccountResponse } from "src/Pages/Company/api/pointsBanks/pointsBanks.models";
import { fetchAccounts } from "src/Pages/Company/api/pointsBanks/clients";

const useAccountsData = (accountOwnerId: string, active: boolean) =>
  useQuery<GetAccountResponse[], Error>({
    queryKey: ["charge-ups-accounts", accountOwnerId],
    queryFn: ({ signal }) => fetchAccounts(accountOwnerId, signal),
    enabled: active && !!accountOwnerId,
  });

export default useAccountsData;
